import { render, staticRenderFns } from "./fclBySeaData.vue?vue&type=template&id=2fea831f&scoped=true"
import script from "./fclBySeaData.vue?vue&type=script&lang=js"
export * from "./fclBySeaData.vue?vue&type=script&lang=js"
import style0 from "./fclBySeaData.vue?vue&type=style&index=0&id=2fea831f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fea831f",
  null
  
)

export default component.exports